export default "__VITE_ASSET__ceaf0416__"